import React from "react";

const typeConfig = {
  triggered: { class: "status-badge badge-primary", text: "Triggered"},
  manual: { class: "status-badge badge-primary", text: "Manual"},
};

export const SmsCampaignTypeBadge = ({ type }) => {
  const normalizedType = type?.toLowerCase();
  const config = typeConfig[normalizedType];

  return (
    <span className={`${config.class}`}>
      {config.text}
    </span>
  );
};

export default SmsCampaignTypeBadge;
